import {ReactComponent as InactiveScheduleIconSvg} from "../../images/command-hub/InactiveScheduleIcon.svg";
import { SvgIcon, SvgIconProps } from "@mui/material";

const InactiveScheduleIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon component={InactiveScheduleIconSvg} {...props} inheritViewBox/>
)

export default InactiveScheduleIcon;